import { ContactOrganizerModal } from 'core/Components';
import { useParams } from 'react-router-dom';
import { useShowConsumerCartItem } from 'store/Api';
import { Button, OneToTwoLayoutTemplate, Stack } from 'ui';
import { useDisclosure } from 'ui/Hooks';

import { PurchaseDetails } from './components/PurchaseDetails';
import { PurchaseDetailSummaryCard } from './components/PurchaseSummary';
import { SendReceipt } from './components/SendReceipt';

const PurchaseDetailPage = () => {
  const [isReceiptModalOpen, receiptModalHandler] = useDisclosure(false);
  const [isContactModalOpen, contactModalHandler] = useDisclosure(false);

  const { cartItemId } = useParams();
  const { data: cartItem } = useShowConsumerCartItem({ cartItemId });

  return (
    <>
      <OneToTwoLayoutTemplate
        leftSection={
          cartItem && (
            <Stack>
              <PurchaseDetailSummaryCard cartItem={cartItem} />

              <Stack gap="xs" visibleFrom="md">
                <Button fullWidth onClick={receiptModalHandler.open}>
                  Send Receipt
                </Button>
                <Button fullWidth variant="outline" onClick={contactModalHandler.open}>
                  Contact Seller
                </Button>
              </Stack>
            </Stack>
          )
        }
        rightSection={cartItem && <PurchaseDetails cartItem={cartItem} />}
        mobileBottomButton={
          <>
            <Button variant="outline" onClick={contactModalHandler.open}>
              Contact Seller
            </Button>
            <Button onClick={receiptModalHandler.open}>Send Receipt</Button>
          </>
        }
      />
      <SendReceipt
        cartItem={cartItem}
        opened={isReceiptModalOpen}
        onClose={receiptModalHandler.close}
      />
      <ContactOrganizerModal
        title="Contact Seller"
        causeId={cartItem?.store_item?.cause_id}
        opened={isContactModalOpen}
        onClose={contactModalHandler.close}
      />
    </>
  );
};

export { PurchaseDetailPage };
